import { render } from "./PlaylistItems.vue?vue&type=template&id=18f585be"
import script from "./PlaylistItems.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaylistItems.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Playlist/PlaylistItems.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18f585be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18f585be', __exports__)) {
    api.reload('18f585be', __exports__)
  }
  
  module.hot.accept("./PlaylistItems.vue?vue&type=template&id=18f585be", () => {
    api.rerender('18f585be', render)
  })

}


export default __exports__